export default __webpack_public_path__ + "static/media/BTC.768cc16e.svg";